// Fetch list

export const FETCH = 'transportConditions.FETCH'
export const FETCH_STARTED = 'transportConditions.FETCH_STARTED'
export const FETCH_FULFILLED = 'transportConditions.FETCH_FULFILLED'
export const FETCH_REJECTED = 'transportConditions.FETCH_REJECTED'
export const FETCH_CANCELLED = 'transportConditions.FETCH_CANCELLED'

export const SORTING_CHANGED = 'transportConditions.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'transportConditions.FETCH_ONE'
export const FETCH_ONE_STARTED = 'transportConditions.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'transportConditions.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'transportConditions.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'transportConditions.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'transportConditions.SAVE'
export const SAVE_STARTED = 'transportConditions.SAVE_STARTED'
export const SAVE_FULFILLED = 'transportConditions.SAVE_FULFILLED'
export const SAVE_REJECTED = 'transportConditions.SAVE_REJECTED'
export const SAVE_CANCELLED = 'transportConditions.SAVE_CANCELLED'

// Delete

export const DELETE = 'transportConditions.DELETE'
export const DELETE_STARTED = 'transportConditions.DELETE_STARTED'
export const DELETE_FULFILLED = 'transportConditions.DELETE_FULFILLED'
export const DELETE_REJECTED = 'transportConditions.DELETE_REJECTED'
export const DELETE_CANCELLED = 'transportConditions.DELETE_CANCELLED'

// Export

export const EXPORT = 'transportConditions.EXPORT'
export const EXPORT_FULFILLED = 'transportConditions.EXPORT_FULFILLED'
